export const SET_PREFERENCES = 'SET_PREFERENCES';
export const SET_PREFERENCE = 'SET_PREFERENCE';
export const ADD_PREFERENCE = 'ADD_PREFERENCE';
export const UPDATE_PREFERENCE = 'UPDATE_PREFERENCE';
export const REMOVE_PREFERENCE = 'REMOVE_PREFERENCE';
export const CLEAR_PREFERENCE = 'CLEAR_PREFERENCE';
export const CLEAR_PREFERENCES = 'CLEAR_PREFERENCES';
